import React from 'react';
import { InputComponentProps } from './types';
import { useInputHelper, FormFieldsData, EnumDropdown } from 'framework/form';

const OfficeTemplateField = ({ source, propertyDetails, renderNestedProperties }: InputComponentProps) => {
  const { getRawOnChangeCallback } = useInputHelper({
    source: `${source}.${propertyDetails.propertyName}`,
  });

  const rawOnChangeCallback = getRawOnChangeCallback();
  const onChangeCallback = (data: FormFieldsData) => {
    if (rawOnChangeCallback) {
      rawOnChangeCallback({
        [`${source}.${propertyDetails.propertyName}`]: [
          {
            value: Object.values(data)[0],
          },
        ],
      });
    }
  };

  return (
    <>
      <EnumDropdown
        options={{
          BY: 'BY',
          PL: 'PL',
        }}
        label=""
        placeholder="Office"
        onChangeCallback={onChangeCallback}
        source={`${source}.${propertyDetails.propertyName}.0.value`}
      />
      {renderNestedProperties?.({
        propertiesSource: `${source}.${propertyDetails.propertyName}.0.properties`,
        propertiesShema: propertyDetails.properties,
      })}
    </>
  );
};

export default OfficeTemplateField;
